import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.patient.code.copy');
import { Input, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-patient-code-copy',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.patient.code.copy/view.scss */
:host {
  display: inline-flex;
  flex: 0 0 auto;
  vertical-align: middle;
}

.patient-code-copy {
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 0.45rem;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background-color 140ms ease, color 140ms ease, transform 140ms ease;
}

.patient-code-copy:hover {
  background: #eef6ff;
  color: #0369a1;
}

.patient-code-copy:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.patient-code-copy:active {
  transform: scale(0.94);
}

.patient-code-copy.is-copied {
  background: #ecfdf5;
  color: #15803d;
}

.patient-code-copy.is-failed {
  background: #fef2f2;
  color: #dc2626;
}

.patient-code-copy:disabled {
  cursor: default;
  opacity: 0.4;
}`],
})
export class ComponentPatientCodeCopyComponent implements OnDestroy {
    @Input() code: string = '';

    public state: 'idle' | 'copied' | 'failed' = 'idle';
    private resetTimer: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public ngOnDestroy() {
        if (this.resetTimer) clearTimeout(this.resetTimer);
    }

    public actionLabel() {
        if (this.state === 'copied') return '환자 코드 복사 완료';
        if (this.state === 'failed') return '환자 코드 복사 실패';
        return '환자 코드 복사';
    }

    public async copy(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        const value = String(this.code || '').trim();
        if (!value) return;

        let copied = false;
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(value);
                copied = true;
            }
        } catch (error) {
            copied = false;
        }

        if (!copied) copied = this.copyWithFallback(value);
        this.state = copied ? 'copied' : 'failed';
        await this.service.render();

        if (this.resetTimer) clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(async () => {
            this.state = 'idle';
            await this.service.render();
        }, 1600);
    }

    private copyWithFallback(value: string) {
        const input = document.createElement('textarea');
        input.value = value;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, input.value.length);

        try {
            return document.execCommand('copy');
        } catch (error) {
            return false;
        } finally {
            document.body.removeChild(input);
        }
    }
}

export default ComponentPatientCodeCopyComponent;